import { useEffect } from "react";
import { useFormikContext } from "formik";
import { toHalfWidth } from "../../helpers/validate-helper";

interface AutoCalculateTaxProps {
  id?:number,
  taxOptions: { id: string | number; value: string }[];
  feeExcludingTaxField: string;
  taxIdField: string;
  taxAmountField: string;
  feeIncludingTaxField: string;
  feeTaxValueField: string;
}

const ProductAutoCalculateTax = ({
  id,
  taxOptions,
  feeExcludingTaxField,
  taxIdField,
  taxAmountField,
  feeIncludingTaxField,
  feeTaxValueField,
}: AutoCalculateTaxProps) => {
  const { values, setFieldValue, initialValues } = useFormikContext<any>();
    const feeIncludingTaxFieldValue = toHalfWidth(values[feeIncludingTaxField]);
    const feeIncludingTaxValue: any = (feeIncludingTaxFieldValue && typeof feeIncludingTaxFieldValue === "string") ? parseInt(feeIncludingTaxFieldValue) : feeIncludingTaxFieldValue; 
    const initialValuesFeeIncludingTaxValue = (initialValues[feeIncludingTaxField] && typeof initialValues[feeIncludingTaxField] === "string") ? parseInt(initialValues[feeIncludingTaxField]) : initialValues[feeIncludingTaxField]; 
    const valuesTaxIdField = (values[taxIdField] && typeof values[taxIdField] === "string") ? parseInt(values[taxIdField]) : values[taxIdField]; 
    const initialValuesTaxIdField = (initialValues[taxIdField] && typeof initialValues[taxIdField] === "string") ? parseInt(initialValues[taxIdField]) : initialValues[taxIdField]; 
    const valuesFeeExcludingTaxField = (values[feeExcludingTaxField] && typeof values[feeExcludingTaxField] === "string") ? parseInt(values[feeExcludingTaxField]) : values[feeExcludingTaxField]; 
    const initialValuesFeeExcludingTaxField = (initialValues[feeExcludingTaxField] && typeof initialValues[feeExcludingTaxField] === "string") ? parseInt(initialValues[feeExcludingTaxField]) : initialValues[feeExcludingTaxField]; 
    const valuesTaxAmountField = (values[taxAmountField] && typeof values[taxAmountField] === "string") ? parseInt(values[taxAmountField]) : values[taxAmountField]; 
    const initialValuesTaxAmountField = (initialValues[taxAmountField] && typeof initialValues[taxAmountField] === "string") ? parseInt(initialValues[taxAmountField]) : initialValues[taxAmountField]; 
    useEffect(() => {
      if (
        values.IsAutoCalculateTax && (feeIncludingTaxValue !== initialValuesFeeIncludingTaxValue ||
          valuesTaxIdField !== initialValuesTaxIdField || valuesFeeExcludingTaxField !== initialValuesFeeExcludingTaxField ||
            valuesTaxAmountField !== initialValuesTaxAmountField) 
          ) { 
            if (valuesTaxIdField) {
              const selectedTax = taxOptions.find((tax) => tax.id == valuesTaxIdField);
  
            if (selectedTax) {
              const taxRate = parseFloat(selectedTax.value.replace("%", "")) || 0;
              const feeExcludingTax = feeIncludingTaxValue / (1 + (taxRate / 100));
              const taxAmount = Math.round(feeIncludingTaxValue - feeExcludingTax);
    
              setFieldValue(taxAmountField, taxAmount?.toString());
              setFieldValue(feeTaxValueField, Math.round(taxRate).toString());
              setFieldValue(feeExcludingTaxField, Math.round(feeIncludingTaxValue - taxAmount).toString());
            }
        }
      }
    }, [values[feeIncludingTaxField], values[taxIdField], setFieldValue, taxOptions, initialValues]);
  
    useEffect(() => {
      if (
        id && id > 0 &&
        !values.IsAutoCalculateTax &&
        (
          initialValuesFeeIncludingTaxValue === feeIncludingTaxValue ||
          initialValuesTaxAmountField === valuesTaxAmountField
        )
      ) {
        setFieldValue("IsAutoCalculateTax", true);
      }
    }, [
      id,
      initialValues.FeeIncludingTax,
      initialValues.TaxAmount,
      values.IsAutoCalculateTax,
      values.feeIncludingTaxField,
      values.TaxAmount,
      setFieldValue
    ]);
  
  return null;
};

export default ProductAutoCalculateTax;
